module.exports = __webpack_public_path__ + "img/oa-interface.8125f8ee.png";